









import Component, { mixins } from "vue-class-component";
import { UserReferringSearchResult } from "@scrile/api-provider/dist/api/UserReferringProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import providers from "@/lib/api";
import { CheckRolePage } from "@/lib/decorators";
import ReferralsView from "./components/ReferralsView.vue";

@CheckRolePage("creator")
@Component({ name: "PageReferrals", components: { ReferralsView } })
export default class PageReferrals extends mixins(WithAuthUser) {
  public loading = false;

  public enableScroll = false;

  public userReferrerPercent: number = 0;

  public userReferringSearchResult: UserReferringSearchResult | null = null;

  public get userReferrings() {
    return this.userReferringSearchResult?.result ?? [];
  }

  public async scrollHandler(cb: Function) {
    try {
      if (!this.userReferringSearchResult?.hasNextPage) return;
      await this.getReferrals(this.userReferringSearchResult.page + 1, false);
    } finally {
      cb();
    }
  }

  public async getReferrals(page: number = 0, replace: boolean = true) {
    try {
      this.enableScroll = false;
      let response = await providers.UserReferringProvider.find({
        data: { referrerId: this.authUserStrict.id, sort: "UPDATE_TIME,DESC", page },
      });
      if (replace) {
        this.userReferringSearchResult = response;
      } else {
        this.userReferringSearchResult = {
          ...response,
          result: [...(this.userReferringSearchResult?.result ?? []), ...response.result],
        };
      }
    } finally {
      this.enableScroll = this.userReferringSearchResult?.hasNextPage ?? false;
    }
  }

  public async getReferrerPercent() {
    const response = await providers.UserReferrerPercentProvider.find({ referrerId: this.authUserStrict.id });
    this.userReferrerPercent = response.percent;
  }

  public async created() {
    try {
      this.loading = true;
      await Promise.all([this.getReferrals(), this.getReferrerPercent()]);
    } finally {
      this.loading = false;
    }
  }
}
